import { render, staticRenderFns } from "./LojasFornecedoresIndex.vue?vue&type=template&id=8eeaa6d2&"
import script from "./LojasFornecedoresIndex.vue?vue&type=script&lang=ts&"
export * from "./LojasFornecedoresIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports